export default "__VITE_ASSET__WoY3TM_h__"